<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    fill="none"
    aria-hidden="true"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
  >
    <path
      d="M20.708 16.11v5.214c0 .265-.176.442-.442.442H2.9c-.265 0-.441-.177-.441-.442V7.227h18.25v5.657"
    />
    <path
      d="M21.106 16.11h-4.508c-.265 0-.442-.177-.442-.442v-2.342c0-.265.177-.442.442-.442h4.463c.265 0 .442.177.442.442v2.298a.422.422 0 0 1-.397.486ZM15.715 5.593h4.551c.266 0 .442.176.442.442v1.193H2.458V6.035c0-.266.176-.442.441-.442h5.966"
    />
    <path d="m7.274 7.183 4.95-4.949 4.949 4.95" />
  </svg>
</template>
